import { Formik, Form } from 'formik'
import { Button } from 'reactstrap'
import { InputField } from 'components/molecules'
import PropTypes from 'prop-types'
import * as Yup from 'yup'

const CODE_FORMATS_OPTIONS = [
  {
    label    : 'Numeric',
    value    : 'numeric',
    formText : 'Digits only [0-9]'
  },
  {
    label    : 'Alphabets',
    value    : 'alphabetical',
    formText : 'Alphabets only [a-z, A-Z]'
  },
  {
    label    : 'Numbers and Alphabets',
    value    : 'alphanumeric',
    formText : 'Mix of digits and alphabets [0-9, a-z, A-Z]'
  }
]

const schema = Yup.object().shape({
  quantity       : Yup.number().positive('Must be positive').min(2, 'Must be more than 1').required('Required'),
  codeLength     : Yup.number().positive('Must be positive').min(5, 'Must be 5 characters or longer').required('Required'),
  codeFormat     : Yup.string().required('Required'),
  codePrefix     : Yup.string(),
  codeSuffix     : Yup.string(),
  from_date      : Yup.string(),
  to_date        : Yup.string(),
  dashCount      : Yup.number().required('Required'),
  usePerCustomer : Yup.number().min(1, 'Must be at least 1').required('Required'),
  usageLimit     : Yup.number().min(1, 'Must be at least 1').required('Required')
})

const initialValues = {
  quantity       : 2,
  codeLength     : 5,
  codeFormat     : CODE_FORMATS_OPTIONS[0].value,
  codePrefix     : 'TL',
  codeSuffix     : '',
  dashCount      : 0,
  from_date      : '',
  to_date        : '',
  usePerCustomer : 1,
  usageLimit     : 1
}
/**
 * Receives user input to autogenerate voucher forms
 * @param {function} onSubmit - function to handle submit from formik
 * @returns
 */
const VoucherCodeGenerateForm = ({ onSubmit }) => {

  const CodeFormatFormText = ({ options }) => (
    options.map((option) => (
      <div key={ `code-format-option-form-text-${option.value}` }>
        <strong>{ option.label }: </strong>{ option.formText }
      </div>
    ))
  )

  return (
    <Formik
      enableReinitialize={ false }
      initialValues={ initialValues }
      validationSchema={ schema }
      onSubmit={ onSubmit }
    >
      {
        (formik) => (
          <Form>
            <InputField
              label={ 'quantity' }
              name={ 'quantity' }
              type={ 'number' }
              required={ true }
              formText={ 'Number of unique codes you want to generate' }
            />
            <InputField
              label={ 'code length' }
              name={ 'codeLength' }
              type={ 'number' }
              min={ 1 }
              required={ true }
              formText={ 'No. of characters in the code' }
            />
            <InputField
              label={ 'code format' }
              name={ 'codeFormat' }
              type={ 'select' }
              required={ true }
              formText={ <CodeFormatFormText options={ CODE_FORMATS_OPTIONS }/> }
            >
              {
                CODE_FORMATS_OPTIONS.map((option) => (
                  <option key={ `code-format-options-${option.value}` } value={ option.value }>
                    { option.label }
                  </option>
                ))
              }
            </InputField>
            <InputField
              label={ 'code prefix' }
              name={ 'codePrefix' }
              type={ 'text' }
              required={ true }
              formText={ 'Generated codes will START with these characters.' }
            />
            <InputField
              label={ 'code suffix' }
              name={ 'codeSuffix' }
              type={ 'text' }
              required={ true }
              formText={ 'Generated codes will END with these characters' }
            />
            <InputField
              label={ 'Dash every N characters' }
              name={ 'dashCount' }
              type={ 'number' }
              required={ true }
              formText={ 'Insert a dash (-) every N characters. E.g. (Dash every 3 characters: TLA-A2B-123' }
            />
            <InputField
              type='date'
              label='Start Date'
              name='from_date'
              formText={ <>
                { 'Tanggal mulai berlaku voucher.' }
                <br />
                { 'Jika kosong, voucher bisa digunakan sesuai dengan "Start Date" yang telah ditentukan di aturan voucher utama' }
              </>
              }
            />
            <InputField
              label='Expiry Date'
              type='date'
              name='to_date'
              formText={ <>
                { 'Tanggal akhir berlakunya voucher.' }
                <br />
                { 'Jika kosong, voucher bisa digunakan sesuai dengan "Expiry Date" yang telah ditentukan di aturan voucher utama.' }
              </>
              }
            />
            <InputField
              label={ 'Use per customer' }
              name={ 'usePerCustomer' }
              type={ 'number' }
              required={ true }
              formText={ 'No. of times a unique customer can use each voucher' }
            />
            <InputField
              label={ 'Usage Limit' }
              name={ 'usageLimit' }
              type={ 'number' }
              required={ true }
              formText={ 'No. of times all customers can use each unique voucher' }
            />
            <Button
              color={ 'primary' }
              type={ 'submit' }
              disabled={ formik.isSubmitting }
            >
              { 'Generate' }
            </Button>
          </Form>
        )
      }
    </Formik>
  )
}

VoucherCodeGenerateForm.propTypes = {
  onSubmit: PropTypes.func
}
export default VoucherCodeGenerateForm